import React from 'react';
import { useSelector } from 'react-redux';
import { Bars } from 'react-loader-spinner';

const Loader = () => {
  const isLoading = useSelector((state) => state.loader.isLoading);
  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <Bars height="80" width="80" color="var(--color-primary)" ariaLabel="bars-loading" visible={isLoading} />
        </div>
      )}
    </div>
  );
};

export default Loader;
